var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareclose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2012 12L19.0562 6.14451C19.3882 5.81341 19.3882 5.27441 19.0562 4.94331C18.7242 4.61131 18.1851 4.61131 17.855 4.94331L12 10.7987L6.14502 4.94331C5.81492 4.61131 5.27392 4.61131 4.94382 4.94331C4.61182 5.27441 4.61182 5.81341 4.94382 6.14451L10.7988 12L4.94382 17.8555C4.61182 18.1866 4.61182 18.7256 4.94382 19.0567C5.10982 19.2227 5.32662 19.3057 5.54442 19.3057C5.76222 19.3057 5.97992 19.2227 6.14502 19.0567L12 13.2013L17.855 19.0567C18.02 19.2227 18.2378 19.3057 18.4556 19.3057C18.6734 19.3057 18.8902 19.2227 19.0562 19.0567C19.3882 18.7256 19.3882 18.1866 19.0562 17.8555L13.2012 12Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareclose);
export default __webpack_public_path__ + "static/media/shareclose.65ff4899230d8066b193cd84a95923a8.svg";
export { ForwardRef as ReactComponent };